import React from "react";
import OrderMain from "../Order";

const DuplicateOrder = () => {
  return <OrderMain module="duplicate-order" title="Duplicate Order" />;
};

export default DuplicateOrder;
